import Vue from 'vue'
import TakibiProductBundleBuilder from '../../vue-components/TakibiProductBundleBuilder.vue'

const takibiApp = new Vue({
    el: "#takibi-app-mount",
    components: {
        'takibi-product-bundle-builder': TakibiProductBundleBuilder
    },
});

// we must attach this app to the window object so we can reference it from the quick view pop up
window.bundleApp = takibiApp
